"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatabaseIconTooltip = exports.DatabaseMediumIcon = exports.DatabaseMastheadIcon = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var icons_1 = require("../../../gen-src/icons");
var MessageUtils_1 = require("../displayUtils/MessageUtils");
var PlaceStyles_1 = require("../style/PlaceStyles");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
function DatabaseMastheadIcon(props) {
    switch (props.database.__typename) {
        case 'CloudFile':
        case 'File':
            return react_1.default.createElement(icons_1.SvgSpacesMastheadFile, { className: PlaceStyles_1.placePageIconClass });
        case 'DatabaseServer':
        case 'WebDataConnector':
            return react_1.default.createElement(icons_1.SvgSpacesMastheadExternalServer, { className: PlaceStyles_1.placePageIconClass });
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props.database.__typename);
            return null;
    }
}
exports.DatabaseMastheadIcon = DatabaseMastheadIcon;
function DatabaseMediumIcon(props) {
    switch (props.database.__typename) {
        case 'CloudFile':
        case 'File':
            return props.database.isCertified ? react_1.default.createElement(icons_1.SvgSpacesMediumFileCertified, null) : react_1.default.createElement(icons_1.SvgSpacesMediumFile, null);
        case 'DatabaseServer':
        case 'WebDataConnector':
            return props.database.isCertified ? react_1.default.createElement(icons_1.SvgSpacesMediumExternalServerCertified, null) : react_1.default.createElement(icons_1.SvgSpacesMediumExternalServer, null);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props.database.__typename);
            return null;
    }
}
exports.DatabaseMediumIcon = DatabaseMediumIcon;
function getDatabaseIconTooltip(database) {
    var friendlyConnectionTypeName = (0, MessageUtils_1.messageForConnectionType)(database.connectionType);
    switch (database.__typename) {
        case 'CloudFile':
        case 'File':
            return database.connectionType ?
                Localize_1.Messages.FileWithType({ type: friendlyConnectionTypeName || '' })
                : Localize_1.Messages.PermissionsRequired();
        case 'DatabaseServer':
        case 'WebDataConnector':
            return database.connectionType ?
                Localize_1.Messages.DatabaseWithType({ type: friendlyConnectionTypeName || '' })
                : Localize_1.Messages.PermissionsRequired();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(database.__typename);
            return '';
    }
}
exports.getDatabaseIconTooltip = getDatabaseIconTooltip;
//# sourceMappingURL=DatabaseIcon.js.map